export default __webpack_public_path__ + "static/media/zero_sac_2.3ddc9f2b.png";